export const product = {
  productDetails: {
    id: 'ID',
    quantity: 'Qty',
    productDetails: 'Product Details',
    specification: 'Specifications',
    reviews: 'Reviews',
    shipping: 'Shipping',
    share: 'Share',
    showReviews: 'Show reviews',
    noReviews: 'No reviews yet',
    productPrice: 'Product Price',
    noProductImage: 'Image not available, {{ product }}',
    representativeImage: 'Image differs from product',
    speedRPM: 'Speed (RPM)',
    outputHP: 'Output (HP)',
    voltage: 'Voltage',
    frameSize: 'Frame Size',
    outputKW: 'Output (KW)',
    mounting: 'Mounting',
    phase: 'Phase',
    enclosure: 'Enclosure',
    application: 'Application',
  },
  productGallery: {
    tabs: {
      photos: 'Photos',
      videos: 'Videos',
    },
  },
  productList: {
    filterBy: {
      label: 'Filter by',
      action: 'Filter by',
    },
    activeFilter: 'Filter {{filter}}, clicking this button will remove the filter',
    appliedFilter: 'Applied filter:',
    showLess: 'Show less...',
    showMore: 'Show more...',
    sortBy: 'Sort by',
    sortResults: 'Sort results',
    backToTopBtn: 'BACK TO TOP',
    showMoreBtn: 'SHOW MORE',
    productSearchPagination: 'Product search pagination',
    productListResults: 'Product Results List',
  },
  productFacetNavigation: {
    filterBy: {
      label: 'Filter by',
      action: 'Filter by',
      facet: 'Filter results by Facets',
      name: 'Filter by {{name}}',
    },
    appliedFilter: 'Applied filter:',
    showLess: 'Show less...',
    showMore: 'Show more...',
    sortBy: 'Sort by',
    ariaLabelShowLess: 'Show less, button, clicking this button will reduce options for the active group',
    ariaLabelShowMore: 'Show more, button, clicking this button will show all options for the active group',
    ariaLabelItemsAvailable: '{{name}}, {{state}} {{count}} item available',
    ariaLabelItemsAvailable_other: '{{name}}, {{state}} {{count}} items available',
    decreaseOptionsVisibility:
      'Options have been hidden from the active group, navigate back to read them or proceed to the next group',
    increaseOptionsVisibility:
      'More options have been added to the active group, navigate back to read them or proceed to the next group',
  },
  productSummary: {
    showReviews: 'Show reviews',
    showReviewsDetailed: 'Show {{count}} reviews, Rated {{rating}} out of 5 stars',
    share: 'Share',
    newItemPrice: 'New item price',
  },
  productReview: {
    overallRating: 'Overall Rating',
    reviewTitle: 'Review Title',
    writeYourComments: 'Write your comments',
    rating: 'Rating',
    ratingRequired: 'Product rating, required',
    addRate: 'Add rating: {{count}} star',
    addRate_other: 'Add rating: {{count}} stars',
    reviewerName: 'Reviewer Name (optional)',
    writeReview: 'Write a Review',
    more: 'Show More Reviews',
    less: 'Show Less Reviews',
    thankYouForReview: 'Thank you for your review! Note: Reviews may need to be moderated before appearing here.',
    postReviewFail: 'Something went wrong while posting your review. Please try again later.',
    ratedOutOf: 'Rated: {{rating}} out of 5',
  },
  productCarousel: {
    carouselLabel: 'Carousel, {{title}}',
  },
  addToCart: {
    itemsAddedToYourCart: 'Item(s) added to your cart',
    itemsIncrementedInYourCart: 'This item was already in your cart. The quantity has been updated.',
    priceZeroException: "This product can't be added to the cart right now. Please ",
    priceZeroExceptionRequestQuote: 'Request a quote',
    priceZeroExceptionFinalMessage: ", and we'll get back to you with more details!",
    items: 'items',
    updatingCart: 'Updating cart...',
    addToCart: 'Add to cart',
    viewCart: 'view cart',
    proceedToCheckout: 'proceed to checkout',
    quantity: 'Qty',
    outOfStock: 'Out of stock',
    inStock: 'In stock',
    selectStyleAndSize: 'Select style and size to check stock',
    removeFromCart: 'Remove Product from Cart',
    closeModal: 'Close Modal',
    buyItAgain: 'Buy Again',
    addToActiveCart: 'Add To Active Cart',
  },
  compare: {
    label: 'Compare Product',
  },
  modifyMotors: {
    label: 'Modify Motor',
  },
  contactOurExperts: {
    label: 'Contact Our Experts',
  },
  productShortcuts: {
    select: {
      label: 'Efficiency',
      placeholder: 'Select a country',
    },
  },
  productPrice: {
    loginRequired: 'Login is Required',
    listPrice: 'List Price',
    yourPrice: 'Your Price',
    difference: 'Difference',
  },
  keyFeatures: {
    noContent: 'No features available',
    keyFeatures: 'Key Features',
    checkInventory: 'Check Inventory',
  },
  TabPanelContainer: {
    tabs: {
      TabEfficiency: 'Efficiency',
      TabResourceCenter: 'Resource Center',
      ProductKeyFeatures: 'Key Features',
      ProductDetailsTabComponent: 'Product Details',
      ProductSpecsTabComponent: 'Specifications',
      ProductReviewsTabComponent: 'Reviews',
      deliveryTab: 'Shipping',
      SparePartsTabComponent: 'Spare Parts',
    },
    tabPanelContainerRegion: 'Tab group with more product details',
  },
  addToWishList: {
    add: 'Add to Favorites',
    remove: 'Remove from Favorites',
    anonymous: 'Log in to add to wishlist',
    addedToWishList: 'Product added to wishlist',
    removedFromWishList: 'Product removed from wishlist',
  },
  stockNotification: {
    notifyMe: 'NOTIFY ME',
    stopNotify: 'STOP NOTIFICATION',
    getNotify: 'Receive a notification when this product is available.',
    getNotifySuffix: 'to be notified when this product is available.',
    activateChannelsPrefix: 'To be notified, you need to activate the ',
    channelsLink: 'Notification Channels',
    activateChannelsSuffix: '.',
    notified: 'You will be notified when this product is back in stock.',
    getNotified: 'Receive a notification when this product is back in stock.',
    unsubscribeSuccess: 'You will no longer receive back in stock notifications for this product.',
    subscriptionDialog: {
      header: 'Out of Stock Notification Subscription',
      notifiedPrefix: 'You will be notified on:',
      notifiedSuffix: 'as soon as this product is back in stock.',
      manageChannelsPrefix: 'Manage your preferred notification channels in the ',
      manageChannelsLink: 'Notification Preferences',
      manageChannelsSuffix: ' page.',
      manageSubscriptionsPrefix: 'You can manage your subscriptions in ',
      manageSubscriptionsLink: 'My Interests',
      manageSubscriptionsSuffix: ' page.',
      okBtn: 'OK',
      subscribing: 'Subscribing to out of stock notifications for this product',
    },
  },
  itemCounter: {
    removeOne: 'Remove one',
    addOneMore: 'Add one more',
    quantity: 'Quantity',
  },
  productView: {
    gridView: 'Select to switch to Grid View',
    listView: 'Select to switch to List View',
    viewMode: 'Compact View',
  },
  productRow: {
    labels: {
      code: `Cod.`,
      catalog: `Catalog`,
    },
    actions: {
      viewDetails: `View Details`,
      whereToBuy: `Where to Buy`,
      addToCompare: `Add to Compare`,
      viewReplacement: `View Replacement`,
    },
    noLonger: 'Sorry, this item is no longer available',
  },
  efficiency: {
    country: 'Country',
    efficiency: 'Complies with standards',
    noInformation: 'Information not available at the moment. Please check back later!',
  },
  inventory: {
    modal: {
      title: 'Check Inventory',
    },
    table: {
      header: {
        warehouse: 'Warehouse',
        qty: 'Qty',
        estShipDate: 'Est Ship Date',
        default: 'DEFAULT',
      },
    },
    noContent: 'No warehouses available.',
    requiredLogin: 'Login is Required',
    complementText: 'to access inventory and shipment dates based on permission.',
    title: 'Click here to change your Warehouse selection',
    label: 'Warehouse',
    action: 'Check Inventory',
  },
  intro: {
    customer: 'Customer',
    part: 'Part',
    catalog: 'Catalog',
    model: 'Model',
    weight: 'Weight',
    unitWeight: 'Unit Weight',
    invoice: 'Invoice',
  },
  resourceCenter: {
    title: 'Resource Center',
    noContent: 'No resource available.',
  },
  shortcuts: {
    noContainer: 'This section is not available for this product.',
  },
  productCrossReference: {
    searchLabel: 'Enter the ID number of the part you are seeking to replace.',
    description:
      ' Whether you’re currently using one of our products or one from a competitor, this tool will help you find the right product match for thousands of products. Here you will find substitute product options for competitor and Regal Rexnord products.',
    placeholder: 'Enter part number or catalog number',
    begins: 'Starts with',
    contains: 'Includes',
    equals: 'Exactly',
    tableHeader: {
      part: 'Part #',
      catalog: 'Catalog #',
      description: 'Description',
    },
    iconInfo: 'Enter partial or exact manufacturer part or catalog number.',
    noProducts: 'No products found',
  },
  productComparator: {
    error: {
      maxProducts:
        'You can compare only {{maxProducts}} products. Please first remove a product before attempting to add another.',
    },
    removeAll: 'Remove All',
    highlightDifferences: 'Highlight Differences',
    product: 'Product',
    catalogNumber: 'Catalog #',
    partNumber: 'Part #',
    removeProduct: 'Remove Product',
    viewType: 'View Type',
    differences: 'Highlight Differences',
    compare: 'Compare',
  },
  productSpecifications: {
    title: 'Specifications',
    loadCurve: 'Load Curve',
    speedCharacteristics: 'Speed Characteristics',
    key: 'Key',
    value: 'Value',
    noContent: 'Information not available at the moment. Please check back later!',
    index_0: {
      perc_rated_load: '% of Rated Load',
      current_amp: 'Current (Amps)',
      rated_output: 'Rated Output (KW)',
      efficiency_pencentage: 'Efficiency (%)',
      power_factor_percentage: 'Power Factor (%)',
      speed_rpm: 'Speed (RPM)',
      temp_rise_fl: 'Temp. Rise @ FL',
      torque_ft_lbs: 'Torque (ft-lbs)',
    },
    titles: {
      curvepoint: 'Curvepoint',
      current_amps: 'Current (Amps)',
      current_percentage: 'Current (%)',
      torque_ft_lbs: 'Torque (ft-lbs)',
      torque_percentage: 'Torque (%)',
      speed_rpm: 'Speed (RPM)',
      rated_output_kw: 'Rated Output (KW)',
      power_factor_percentage: 'Power Factor (%)',
      rated_output_hp: 'Rated Output (Hp)',
    },
  },
  productListItem: {
    speedRPM: 'Speed (RPM)',
    outputHP: 'Output (HP)',
    voltage: 'Voltage',
    frameSize: 'Frame Size',
    outputKW: 'Output (KW)',
    mounting: 'Mounting',
    phase: 'Phase',
    enclosure: 'Enclosure',
    application: 'Application',
  },
};
